import { useState, useEffect, useCallback } from 'react';
import {
  subscribe,
  getStatus,
  processAll,
  retryFailed,
  type SyncStatusCounts
} from '@services/offlineSyncService';

const useSyncStatus = () => {
  const [status, setStatus] = useState<SyncStatusCounts>({
    pending: 0,
    failed: 0,
    syncing: 0
  });

  const refresh = useCallback(async () => {
    try {
      setStatus(await getStatus());
    } catch {
      // No authenticated user yet — keep defaults
    }
  }, []);

  useEffect(() => {
    refresh();
    return subscribe(refresh);
  }, [refresh]);

  return {
    ...status,
    syncAll: processAll,
    retryFailed
  };
};

export default useSyncStatus;
